import { render } from "./ExportInterfaceForm.vue?vue&type=template&id=c22f7c0c&scoped=true&ts=true"
import script from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"
export * from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"

import "./ExportInterfaceForm.vue?vue&type=style&index=0&id=c22f7c0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22f7c0c"]])

export default __exports__